import { createSlice } from '@reduxjs/toolkit';
import { productGalleryTitleCreate } from './productGalleryTitleAsyncThunk';

const productGalleryTitleCreateSlice = createSlice({
  name: "productGalleryTitle",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productGalleryTitleCreate.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productGalleryTitleCreate.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productGalleryTitleCreate.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productGalleryTitleCreateSlice.reducer;